import Dropdown from '../components/dropdown';
import axios from 'axios';
import jQuery from 'jquery'
export default function contact() {
	setupDropdowns();
	setupPostcodeLookup();

	var inputs = Array.from(document.querySelectorAll(`input[name=enquiryType], input[name=enquirySector]`))

	if (!inputs.length) return false;
	inputs.forEach(input => input.value = 'N/A');
}

function addValue(inputName = '', value) {
	if (!inputName.length) return false;
	var inputs = document.querySelectorAll(`input[name=${inputName}]`);
	if (!inputs.length) return false;
	Array.from(inputs).forEach(input => input.value = value);
}





function setupDropdowns() {
	const dropdownElements = document.querySelectorAll('.contact-options .dropdown');

	Array.from(dropdownElements).forEach(dropdownElement => {
		const dropdown = new Dropdown(dropdownElement);
		dropdown.addEventListener('optionChosen', ({ detail }) => firstLevelDropdownAction(detail));
	})

	function firstLevelDropdownAction(detail) {
		document.querySelector('.intro-text').classList.add('is-closed');
		var sectionToShow = detail.sectionEl;
		var optionValue = detail.optionValue;
		var hiddenInputName;

		if (sectionToShow) {
			hiddenInputName = 'enquiryType';
			Array.from(document.querySelectorAll('.contact-section')).forEach(el => el.classList.remove('is-open'));
			sectionToShow.classList.add('is-open');
			window.shownSection = optionValue;

		} else if (optionValue && optionValue.length) { //suboptions
			hiddenInputName = 'enquirySector';

			Array.from(document.querySelectorAll('.contact-section.is-open .form-btm-desc[data-suboption-name]')).forEach((el) => {
				el.style.display = (el.getAttribute('data-suboption-name') === optionValue) ? 'block' : 'none';
			})

			const isDryWasteSection = optionValue === 'dry waste';
			const activeSectionForm = document.querySelector('.contact-section.is-open .contact-form__container .wpcf7');
			const activeSectionTopDesc = document.querySelector('.contact-section.is-open .contact-form__container .form-top-desc');
			var dryWasteSection = jQuery('.contact-section.is-open .dry-waste-postcode-form');

			jQuery(document.querySelector('.contact-section.is-open .contact-form__container')).slideDown();

			if (isDryWasteSection) {
				dryWasteSection.find('input[name=Postcode]').val('');
				dryWasteSection.slideDown();
				activeSectionForm.style.display = 'none';
				activeSectionTopDesc.style.display = 'none';
			} else {
				dryWasteSection.find('input[name=Postcode]').val('');
				dryWasteSection.slideUp();
				jQuery(activeSectionForm).slideDown();
				jQuery(activeSectionTopDesc).slideDown();
			}

		}

		addValue(hiddenInputName, optionValue);
	}
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};

/**

User types postcode

fetch https://api.postcodes.io/outcodes/{{ firstpartofpostcode }}/nearest
get lat - lng





 */
class PostcodeLookup {
	constructor(input) {
		this.input = input;
		this.outcode = '';
		this.locations = window.locations;
		this.closestLocation = {};

		this.input.addEventListener('keyup', (e) => {
			debouncedInputEvent(e);
		});

		const debouncedInputEvent = debounce(e => {
			this.onInput(e);
		}, 800);
	}

	onInput(e) {
		const postcode = e.target.value.toUpperCase();

		/* tests to see if string is in correct UK style postcode: AL1 1AB, BM1 5YZ etc. */
		function isValidPostcode(p) {
			var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
			return postcodeRegEx.test(p);
		}

		/* formats a VALID postcode nicely: AB120XY -> AB1 0XY */
		function formatPostcode(p) {
			var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i;
			return p.replace(postcodeRegEx, '$1 $2');
		}

		if (isValidPostcode(postcode)) {
			const formatted = formatPostcode(postcode);
			this.outcode = formatted.split(' ')[0];
		} else {
			this.outcode = postcode.trim().split(' ')[0];
		}

		if (this.outcode.length) {
			this.search();
		} else {
			this.resetClosestLocation();
		}

	}

	search() {
		this.getClosestLocation();
		this.setClosestLocation();
	}

	getClosestLocation() {
		const match = this.locations.filter(location => {
			const postcodes = location.postcodes;
			var hasMatch = postcodes.some(postcode => new RegExp(this.outcode).test(postcode) );
			if (hasMatch) {
				return location;
			}
		});

		if (match && match.length) {
			this.closestLocation = match[0];
		} else {
			this.closestLocation = this.getDefaultLocation();
		}
	}

	getDefaultLocation() {
		return this.locations.filter(l => l.name === 'Slough')[0];
	}

	setClosestLocation() {
		const dryWasteTextEl = document.querySelector('.contact-section.is-open .form-btm-desc[data-suboption-name="Dry waste"]');
		const hiddenInput = document.querySelector('.contact-section.is-open input[name=closestLocation]');
		const postcodeResultEl = document.querySelector('.contact-section.is-open .postcode-results');

		postcodeResultEl.innerHTML = `Your closest location is ${this.closestLocation.name}.`

		const departmentPrefix = (window.shownSection === 'discuss my current service')
			? 'orders.' : 'sales.';

		const emailAddress = departmentPrefix + this.closestLocation.send_to;
		const tel = this.closestLocation.tel;
		const telWithSpacesRemoved = tel.replace(/\s/g,'');

		const htmlStr = `Alternatively, if you’d like to contact us directly please email <a href="mailto:${emailAddress}">${emailAddress}</a> or call us on <a href="tel:${telWithSpacesRemoved}">${tel}</a>`
		dryWasteTextEl.innerHTML = htmlStr;

		dryWasteTextEl.style.display = '';

		const activeSectionForm = jQuery(document.querySelector('.contact-section.is-open .contact-form__container .wpcf7'));
		const activeSectionTopDesc = jQuery(document.querySelector('.contact-section.is-open .contact-form__container .form-top-desc'));

		activeSectionTopDesc.slideDown();
		activeSectionForm.slideDown();

		// Set the hidden input
		hiddenInput.value = this.closestLocation.name;
		document.querySelector('.postcode-filler').value = document.querySelector('input[name=Postcode]').value;
	}

	resetClosestLocation() {
		const dryWasteTextEl = document.querySelector('.contact-section.is-open .form-btm-desc[data-suboption-name="Dry waste"]');
		const hiddenInput = document.querySelector('.contact-section.is-open input[name=closestLocation]');
		const postcodeResultEl = document.querySelector('.contact-section.is-open .postcode-results');

		const activeSectionForm = jQuery(document.querySelector('.contact-section.is-open .contact-form__container .wpcf7'));
		const activeSectionTopDesc = jQuery(document.querySelector('.contact-section.is-open .contact-form__container .form-top-desc'));
		activeSectionForm.slideUp();
		activeSectionTopDesc.slideUp();

		postcodeResultEl.innerHTML = '';

		dryWasteTextEl.innerHTML = '';
		dryWasteTextEl.style.display = 'none';

		hiddenInput.value = '';
	}
}


function setupPostcodeLookup() {
	const postcodeInputs = Array.from(document.querySelectorAll('input[name=Postcode]'));

	const instances = postcodeInputs.map(input => {
		const pl = new PostcodeLookup(input);
		window.pl = pl;
	});
}